window.interactiveLabel = function (e) {
  const target = e.currentTarget;
  const labelSelector = target.dataset.label;
  if (labelSelector) {
    document.querySelectorAll(labelSelector).forEach((node) => {
      if (target.value) {
        node.classList.add('show');
      } else {
        node.classList.remove('show');
      }
    });
  }
};

window.toggleViewPassword = function (event) {
  const target = event.currentTarget;
  const selector = target.dataset.input;
  const node = document.querySelector(selector);
  if (node) {
    node.type = node.type === 'text' ? 'password' : 'text';
  }
};
